/**
 * Слайдеры
 */
export class Slider {
    constructor(slider) {
        this.container = slider;
        this.slider = this.container.querySelector('.js-slider-swiper');
        this.init();
    }



    // Инициализация обычного слайдера
    init() {
        this.swiper = new Swiper(this.slider, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 8,
            threshold: 10,
            roundLengths: true,
            speed: 700,
            watchOverflow: true,
            watchSlidesVisibility: true,
            a11y: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true
            },
            pagination: {
                el: this.container.querySelector('.js-slider-pagination'),
                clickable: true
            },
            navigation: {
                prevEl: this.container.querySelector('.js-slider-prev'),
                nextEl: this.container.querySelector('.js-slider-next'),
                disabledClass: '_is-disabled'
            },
            on: {
                slideChange: () => {
                    this.stopVideo();
                }
            },
            breakpoints: {
                768: {
                    spaceBetween: 15,
                }
            },
        });
    }


    // Останавливаем запущенное в слайдере видео
    stopVideo() {
        const videos = this.slider.querySelectorAll('.js-video._is-active');
        videos.forEach(video => {
            video.classList.remove('_is-active');
            if (!video.classList.contains('js-plyr-wrapper')) {
                video.querySelectorAll('iframe').forEach(iframe => iframe.remove());
            } else {
                video.querySelectorAll('.plyr').forEach(plyr => plyr.remove());
            }
        });
    }
}



document.querySelectorAll('.js-slider').forEach(el => {
    new Slider(el);
});



// WEBPACK FOOTER //
// ./_src/js/Slider.js